import { render, staticRenderFns } from "./MediacenterPage.vue?vue&type=template&id=27fd6b0a"
import script from "./MediacenterPage.vue?vue&type=script&lang=js"
export * from "./MediacenterPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports